export const getImage = img => {
  try {
    return require(`../../assets/${img}`)
  } catch (error) {
    return ''
  }
}
